import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResponseFormComponent } from './responseform.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [ResponseFormComponent],
  exports: [ResponseFormComponent]
})
export class ResponseFormModule { }
